import { useEffect, useState } from "react";
import useApiClient from "../useApiClient";
import { useFlightContext } from "./useFlightContext";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { createConfirmationPayload } from "helpers/flightHelper";
import { toast } from "react-toastify";
import { useLoadingContext } from "states/loadingContext";
import useMimir from "hooks/useMimir";
import { pixelEvent } from "helpers/common";

const useFlightConfirmation = () => {
    const { airValidateResults, passengersInfos } = useFlightContext();
    const navigate = useNavigate();
    const { api, urls } = useApiClient();
    const { i18n ,t } = useTranslation();
    const [loading, setLoading] = useState(false);
    const [showRequestBooking, setShowRequestBooking] = useState(false);
    const { showLoading, hideLoading } = useLoadingContext();
    const { mimir } = useMimir()

    useEffect(() => {
        if (!airValidateResults || !passengersInfos) {
            navigate("/flights/list");
        }
    }, [airValidateResults, navigate, passengersInfos]);

    const buildMimirPayload = (payload, result) => {
        return {
            type: "FLIGHT",
            event: "CONFIRMATION",
            param1: JSON.stringify(payload || {}),
            param2: JSON.stringify(result || {}),
        };
    };


    const confirmBooking = async (paymentMethod, captchaToken) => {
        const payload = createConfirmationPayload(
            airValidateResults?.flight,
            passengersInfos
        );
        pixelEvent(payload["total_price"], "DZD")
        if (!payload) return;
        setLoading(true);
        showLoading();
        payload["language"] = i18n.language;
        if (captchaToken) {
            payload["recaptchaToken"] = captchaToken;
        }
        payload["captchaToken"] = captchaToken;
        let result;
        if (paymentMethod === "CIB") {
            try {
                payload["fop"] = paymentMethod;
                const res = await api.post(
                    urls.flight.confirmation,
                    JSON.stringify(payload)
                );
                result = res?.data;
                if (res?.data["success"] && res?.data["redirect"]) {
                    window.location.href = res?.data["redirect_to"];
                    return;
                }
                toast.error(
                    "Something went wrong while processing your payment, please try again later."
                );
            } catch (error) {
                if (error?.code === "ERR_NETWORK") {
                    toast.error("Network error, please try again later.");
                    return;
                }
                console.error(error);
                toast.error("Something went wrong, please try again late");
            } finally {
                setLoading(false);
                hideLoading();
                mimir.log(buildMimirPayload(payload,result))
            }
        } else {
            try {
                const res = await api.post(
                    urls.flight.confirmationDelivery,
                    JSON.stringify(payload)
                );
                result = res?.data;
                if (res?.data["success"]) {
                    setShowRequestBooking(true);
                    console.log("success");
                    return;
                }

                if (res?.data["result"]["IBE_Errors"]) {
                    toast.error(t("deliveryError"));
                    return;
                }
            } catch (error) {
                if (error?.code === "ERR_NETWORK") {
                    toast.error("Network error, please try again later.");
                    return;
                }
                console.error(error);
                toast.error(t("deliveryError"));
            } finally {
                setLoading(false);
                hideLoading();
                mimir.log(buildMimirPayload(payload,result))
            }
        }
    };

    return {
        confirmBooking,
        loading,
        showRequestBooking,
    };
};
export default useFlightConfirmation;
